import MainPage from "./otp-report.container";

export default MainPage;
